import { Game, BoughtGame } from "../types/game";
import { Itter } from "../utils/utils";

const games = () => {
  const available: Game[] = Itter(50, (i) => ({
    code: i.toString(),
    cost: Infinity,
    steamId: "",
    rating: "EE",
    system: "Steam",
    title: "Terra - The Card Game"
  }));

  const purchased: BoughtGame[] = Itter(50, i => ({
    code: i.toString(),
    cost: Infinity,
    steamId: "",
    rating: "EE",
    system: "Steam",
    title: "Terra - The Card Game",
    key: "",
    date: "Jan 1st, 2025",
    recipient: "Icarus - Bird Bot of Legend"
  }));

  return { available, purchased };
}

export default games